import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import UploadDocuments from 'modules/tasks/components/TaskDetails/UploadDocuments'
import { TaskDetail } from 'modules/tasks/components/TaskElement/useTaskDetail'

interface Props {
  task: TaskDetail
  canEmployeeManageAnyEmployeeFolder: boolean
}

const UploadDocumentsTypeAttachments = ({ task, canEmployeeManageAnyEmployeeFolder }: Props) => {
  const employeeId = task.uploadDocumentTypeData?.employeeId

  if (!employeeId) return

  return (
    <UploadDocuments
      task={task}
      title={i18n.t('tasks.types.upload_document.details.title')}
      description={i18n.t('tasks.types.upload_document.details.description', {
        folder: task?.uploadDocumentTypeData?.folderName,
      })}
      employeeId={employeeId}
      canEmployeeManageAnyEmployeeFolder={canEmployeeManageAnyEmployeeFolder}
    />
  )
}
export default observer(UploadDocumentsTypeAttachments)
